<template lang="pug">
header(:class="{ fixed: isFixedHeader }")
  .mobile(v-show="isMobile")
    .main-header.clearfix(v-bind:class="{ mobile: isMobile }")
      .pull-left
        i.hamburger.glyphicon.glyphicon-menu-hamburger(@click.stop="toggleMenuSidebar()")
      router-link.pull-left(tag="div",
        :to="{ name: 'homepage' }",
        v-bind:class="{ mobile: isMobile, logo: displayDebutHeader, 'company-logo': displayCompanyHeader }")
      .pull-right
        router-link(:to="{ name: 'signup' }", v-if="!isLogin", @click.native="saveReferrerUrl()") {{ $t('header.login') }}
        .mobil-login-avatar(v-if="isLogin", @click.stop="toggleUserSidebar()")
          img.img-circle(v-if="isLogin && displayDebutHeader", v-bind:src="generateUserAvatar")
          img.img-circle(v-if="isManiplatorLogin && displayCompanyHeader", v-bind:src="generateManipulatorAvatar")
  .desktop(v-show="!isMobile")
    .main-header.clearfix(v-if="displayMainHeader")
      .pull-left
        nav
          router-link.btn(:to="{ name: 'homepage' }", :class="{ hasUnderTriangle : displayDebutHeader }") {{ $t('header.debut') }}
          router-link.btn(:to="{ name: 'companySignup' }", :class="{ hasUnderTriangle : displayCompanyHeader }") {{ $t('header.manipulator') }}
          a.btn(:href="bhDomain", target="_blank") {{ $t('header.bhuntr') }}
    .sub-header.clearfix
      .pull-left
        router-link.logo(:class="{ logo: displayDebutHeader, 'company-logo': displayCompanyHeader }", :to="{ name: 'homepage' }")
        ul.main-nav(v-if="displayDebutHeader")
          router-link.pointer(tag="li", :class="{ actived: activeSubNav === 'internsList' }", :to="{ name: 'internsList' }")
            img(src="~assets/header_icon/icon_joblist_h.png")
            img(src="~assets/header_icon/icon_joblist_n.png")
            p {{ $t('header.findJob') }}
          router-link.pointer(tag="li", :class="{ actived: activeSubNav === 'companyList' }", :to="{ name: 'companyList' }")
            img(src="~assets/header_icon/icon_companylist_h.png")
            img(src="~assets/header_icon/icon_companylist_n.png")
            p {{ $t('header.findCompany' )}}
        ul.main-nav(v-if="isManiplatorLogin && displayCompanyHeader")
          router-link.pointer(tag="li", :class="{ actived: activeSubNav === 'companyCareerList' }", :to="{ name: 'companyCareerList' }")
            img(src="~assets/header_icon/icon_job_n.png")
            img(src="~assets/header_icon/icon_job_h.png")
            p {{ $t('header.vacancies') }}
          router-link.pointer(tag="li", :class="{ actived: activeSubNav === 'companyResumeList' }", :to="{ name: 'companyResumeList' }")
            img(src="~assets/header_icon/icon_resume_n.png")
            img(src="~assets/header_icon/icon_resume_h.png")
            p {{ $t('header.resumes') }}
          router-link.pointer(tag="li", :class="{ actived: activeSubNav === 'companyProfile' }", :to="{ name: 'companyProfile' }")
            img(src="~assets/header_icon/icon_companyinfo_n.png")
            img(src="~assets/header_icon/icon_companyinfo_h.png")
            p {{ $t('header.companyImformation') }}
      .pull-right
        .header__user-info-wrapper.clearfix(v-if="userTypeCheck")
          .header__user-avatar
            img.img-circle(v-if="isLogin && displayDebutHeader", v-bind:src="generateUserAvatar")
            img.img-circle(v-if="isManiplatorLogin && displayCompanyHeader", v-bind:src="generateManipulatorAvatar")
          .header__user-data
            .name(v-if="isLogin && displayDebutHeader") {{ getUserData.displayName }}
            .name(v-if="isManiplatorLogin && displayCompanyHeader") {{ getManipulatorData.displayName }}
            i.glyphicon.glyphicon-triangle-bottom
            .header__user-dropdown_menu(v-if="isManiplatorLogin && displayCompanyHeader")
              ul.style-none
                router-link.pointer(tag="li", :to="{ name: 'companySettings' }") {{ $t('header.accountSettings') }}
                router-link.pointer(tag="li", :to="{ name: 'homepage' }", @click.native="doManipulatorLogout()") {{ $t('header.doLogout') }}
            .header__user-dropdown_menu(v-else)
              ul.style-none
                router-link.pink.pointer(tag="li", :to="{ name: 'userResumeHistory', params: { alias: getUserData.alias } }") {{ $t('header.recruitHistory') }}
                router-link.pink.pointer(tag="li", :to="{ name: 'userInternsSave', params: { alias: getUserData.alias } }") {{ $t('header.savedVacancies') }}
                router-link.pink.pointer(tag="li", :to="{ name: 'userResumeList', params: { alias: getUserData.alias } }") {{ $t('header.manageResumes') }}
              hr
              ul.style-none
                router-link.pointer(tag="li", :to="{ name: 'userProfiles', params: { alias: getUserData.alias } }") {{ $t('header.userSettings') }}
                router-link.pointer(tag="li", :to="{ name: 'userSettings', params: { alias: getUserData.alias } }") {{ $t('header.accountSettings') }}
                router-link.pointer(tag="li", :to="{ name: 'homepage' }", @click.native="doLogout()") {{ $t('header.doLogout') }}
        .header__org-dialog
          a.sign-in(v-if="isNotSignupPage && !userTypeCheck", @click.prevent="showLoginDialog()") {{ $t('header.login') }}
          a.sign-in(v-if="isNotSignupPage && !userTypeCheck", @click.prevent="showSignupDialog()") {{ $t('header.signup') }}
        //- .ph-dropdown-menu.location.pointer(
        //-   style="display: inline-block; margin-right: 8px;")
        //-   .img-wrap
        //-     img.img-circle(v-bind:src="localeIcon")
        //-   .ph-dropdown-menu__content
        //-     ul.style-none
        //-       li(v-for="(lang, key) in locales")
        //-         a(v-bind:href="lang.url"): img.img-circle(:src="lang.icon")
  alert(v-model="showAlertBox",
    placement="top-right",
    duration="3000",
    width="300px",
    type="success",
    dismissable)
    span.alert-icon-float-left.icon-ok-circle
    strong(v-if="isSuccessAlert") {{ $t('loginMessage.succeeded') }}
    strong(v-else) {{ $t('loginMessage.failed') }}
</template>

<script>
import { alert } from 'vue-strap'
import { mapActions, mapGetters } from 'vuex'
import cookies from 'utilities/cookies'

export default {
  components: {
    alert: alert
  },
  mounted () {
    if (this.getUserData.organizer !== null &&
      typeof this.getUserData.organizer !== 'undefined' &&
      this.getUserData.organizer.length > 0
    ) {
      this.userHasOrganizer = true
    }
    window.addEventListener('scroll', this.windowScroller, false)
    window.addEventListener('resize', this.windowResizer, false)
  },
  data () {
    return {
      isMobile: window.innerWidth < 992,
      offCanvas: false,
      userHasOrganizer: false,
      scrollTop: 0,
      isNotSignupPage: false,
      isDisplayDebutHeader: true,
      isDisplayCompanyHeader: false,
      showAlertBox: false,
      isFixedHeader: false,
      bhDomain: process.env.BH_DOMAIN
    }
  },
  computed: {
    userTypeCheck () {
      if ((this.isManiplatorLogin && this.displayCompanyHeader) ||
        (this.isLogin && this.displayDebutHeader)
      ) {
        return true
      }
      return false
    },
    isSuccessAlert () {
      return this.isShowLoginAlert.isSucceeded
    },
    displayMainHeader () {
      if (typeof this.$store.state.route !== 'undefined') {
        if (typeof this.$store.state.route.meta !== 'undefined') {
          return this.$store.state.route.meta.displayMainHeader || true
        }
      }
      return true
    },
    displayDebutHeader () {
      if (typeof this.$store.state.route !== 'undefined') {
        if (typeof this.$store.state.route.meta !== 'undefined') {
          return this.$store.state.route.meta.displayDebutHeader || false
        }
      }
      return true
    },
    displayCompanyHeader () {
      if (typeof this.$store.state.route !== 'undefined') {
        if (typeof this.$store.state.route.meta !== 'undefined') {
          return this.$store.state.route.meta.displayCompanyHeader || false
        }
      }
      return false
    },
    isLogin () {
      return this.getToken !== '' && typeof this.getToken !== 'undefined' && this.getUserData.id !== ''
    },
    isManiplatorLogin () {
      return this.getManipulatorToken !== '' && typeof this.getManipulatorToken !== 'undefined' && this.getManipulatorData.id !== '' && this.getManipulatorData.manipulator === true
    },
    generateUserAvatar () {
      if (typeof this.getUserData.avatar !== 'undefined') {
        if (typeof this.getUserData.avatar.url !== 'undefined') {
          return this.getUserData.avatar.url
        }
      }
      return require('assets/avatar.png')
    },
    generateManipulatorAvatar () {
      if (typeof this.getManipulatorData.avatar !== 'undefined') {
        if (typeof this.getManipulatorData.avatar.url !== 'undefined') {
          return this.getManipulatorData.avatar.url
        }
      }
      return require('assets/avatar.png')
    },
    activeSubNav () {
      if (typeof this.$store.state.route !== 'undefined') {
        if (this.$store.state.route.name === 'internsList' ||
          this.$store.state.route.name === 'homepage'
        ) {
          return 'internsList'
        }
        return this.$store.state.route.name
      }
      return ''
    },
    ...mapGetters({
      getToken: 'users/getToken',
      getUserData: 'users/getUserData',
      getManipulatorToken: 'manipulators/getToken',
      getManipulatorData: 'manipulators/getUserData',
      isShowLoginAlert: 'utilities/isShowLoginAlert'
    })
  },
  methods: {
    windowScroller () {
      this.scrollTop = isNaN(window.scrollTop) ? window.pageYOffset : window.scrollTop
      this.isFixedHeader = this.scrollTop > 100
    },
    windowResizer () {
      this.isMobile = window.innerWidth < 992
    },
    showLoginDialog () {
      this.$router.replace({
        query: Object.assign({}, this.$route.query, { login_type: 'login' })
      })
      this.saveReferrerUrl()
      this.showLoginModal()
    },
    showSignupDialog () {
      this.$router.replace({
        query: Object.assign({}, this.$route.query, { login_type: 'signup' })
      })
      this.saveReferrerUrl()
      this.showLoginModal()
    },
    saveReferrerUrl () {
      cookies.set('referrerUrl', window.location.href, { expires: 300 })
    },
    doLogout () {
      this.logout().then(() => {
        this.showLoginAlert({
          isShow: true,
          isSucceeded: false
        })
        this.$router.push({ name: 'homepage' })
      })
    },
    doManipulatorLogout () {
      this.manipulatorLogout().then(() => {
        this.showLoginAlert({
          isShow: true,
          isSucceeded: false
        })
        this.$router.push({ name: 'companySignup' })
      })
    },
    ...mapActions({
      logout: 'users/logout',
      manipulatorLogout: 'manipulators/logout',
      fetchUserData: 'users/fetchUserData',
      showLoginModal: 'utilities/showLoginModal',
      showLoginAlert: 'utilities/showLoginAlert',
      toggleMenuSidebar: 'utilities/toggleMenuSidebar',
      toggleUserSidebar: 'utilities/toggleUserSidebar'
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.windowScroller, false)
    window.removeEventListener('resize', this.windowResizer, false)
  },
  watch: {
    'isShowLoginAlert' (alert) {
      this.showAlertBox = !!alert.isShow
    },
    '$store.state.route.name' (name) {
      this.isNotSignupPage = !/(signup|login|signin|oauth)/gi.test(name)
    }
  }
}
</script>


<style lang="sass" scoped>
@import "~globalStyles/variables"
header
  &.fixed
    position: fixed
    z-index: 9
    width: 100%
    top: 0
    left: 0
    .sub-header
      .pull-left
        .logo
          margin-top: 5px
          background-size: contain
          background-repeat: no-repeat
          height: 35px
          width: 120px
        ul.main-nav
          height: 46px
          padding:
            top: 8px
            left: 0px
          li
            img:nth-child(1), img:nth-child(2)
              display: none
            &.pointer
              cursor: pointer
            p
              margin-bottom: 8px
      .pull-right
        height: 46px
        .header__user-info-wrapper
          .header__user-avatar
            padding-top: 8px
            img
              width: 30px
              height: 30px
          .header__user-data
            padding: 9px 0
            .name
              padding-top: 4px
            .level, .meter
              display: none
            .header__user-dropdown_menu
              top: 54px
              rigth: -1px
        .header__org-dialog
          margin-top: 14px
        .ph-dropdown-menu
          margin-top: 8px
  .main-header
    background: black
    padding: 5px 30px
    color: $white
    a
      color: $white
      &.btn
        padding: 3px 12px
        &.hasUnderTriangle
          position: relative
          &:after
            content: ''
            position: absolute
            bottom: -6px
            right: calc(50% - 5px)
            width: 0
            height: 0
            border-top: solid 5px transparent
            border-left: solid 5px transparent
            border-right: solid 5px transparent
            border-bottom: solid 5px $white
    &.mobile
      height: 70px
      text-align: center
      padding: 0px 20px 0 20px
      .pull-left
        margin-top: 10px
        i.hamburger
          font-size: 22px
          padding-top: 12px
      .pull-right
        margin-top: 10px
        a
          font-size: 16px
          line-height: 50px
          text-decoration: none
        .mobil-login-avatar
          cursor: pointer
          img
            width: 42px
            height: 42px
      .logo,
      .company-logo
        margin-left: calc(50% - 102px)
        background-repeat: no-repeat
        background-size: contain
      .logo
        margin-top: 5px
        width: 161px
        height: 60px
        display: inline-block
        background-image: url('../assets/header_logo.png')
      .company-logo
        width: 270px
        height: 54px
        display: inline-block
        margin-left: calc(50% - 158px)
        background-image: url('../assets/header_company_logo.png')
      @media (max-width: 370px)
        height: 64px
        .company-logo
          width: 214px
          margin-left: calc(50% - 130px)
  .sub-header
    background-color: $white
    padding: 0px 30px 0px 30px
    .pull-left
      .logo
        width: 161px
        height: 60px
        display: block
        background-image: url('../assets/header_logo.png')
        float: left
        margin-top: 10px
      .company-logo
        width: 270px
        height: 54px
        display: block
        background-image: url('../assets/header_company_logo.png')
        float: left
        margin-top: 16px
        margin-bottom: 16px
      ul.main-nav
        height: 86px
        float: left
        list-style: none
        margin: 0
        padding-top: 10px
        li
          display: inline-block
          width: 76px
          text-align: center
          margin-right: 12px
          &.actived
            border-bottom: 4px solid $pink-2
          &:last-child
            margin-right: 0px
          img:nth-child(1)
            display: inherit
            width: 40px
          img:nth-child(2)
            display: none
          a
            text-decoration: none
            color: $black
          p
            font-size: 14px
            margin-top: 6px
            margin-bottom: 6px
          &:hover
            img:nth-child(1)
              display: none
            img:nth-child(2)
              display: inherit
              width: 40px
    .pull-right
      height: 86px
      .header__user-info-wrapper
        display: block
        float: left
        margin-right: 15px
        position: relative
        .header__user-avatar
          float: left
          margin-right: 15px
          padding-top: 12px
          img
            width: 60px
            height: 60px
        .header__user-data
          float: left
          height: 86px
          padding: 31px 0
          .name
            font-size: 16px
            display: inline-block
            margin-right: 6px
          .header__user-dropdown_menu
            display: none
            position: absolute
            top: 86px
            background-color: $white
            color: $grey
            width: 180px
            text-align: center
            right: 15px
            box-shadow: 0 0 10px 2px #888888
            +border-radius(3px)
            hr
              margin: 0
            li
              padding: 8px 0 8px 0
              &:hover
                background-color: $light-grey-2
              a
                color: $grey
                text-decoration: none
                &.pink
                  color: $pink-2
            &:before
              content: ''
              position: absolute
              top: -15px
              right: 0px
              width: 0
              height: 0
              border-top: solid 8px transparent
              border-left: solid 8px transparent
              border-right: solid 8px transparent
              border-bottom: solid 8px $white
          &:hover
            .header__user-dropdown_menu
              display: block
      .header__org-dialog
        display: block
        float: left
        margin-right: 15px
        margin-top: 32px
        a
          color: $black
          text-decoration: none
          &.organizer-dashboard
              color: $green
        .sign-in
          cursor: pointer
          margin-left: 16px
      .ph-dropdown-menu
        float: left
        position: relative
        margin-top: 25px
        img
          position: relative
          z-index: 2
        &__content
          position: absolute
          right: 0
          top: 0
          z-index: 1
          padding-top: 0
          overflow: hidden
          max-height: 0
          +transition(all, 0.3s, ease)
          ul
            li
              margin: 6px 0
              a
                +opacity(0.7)
                +transition(opacity, 0.3s, ease)
                &:hover
                  +opacity(1)
        &:hover
          .ph-dropdown-menu__content
            display: block
            padding-top: 30px
            max-height: 300px
</style>



// WEBPACK FOOTER //
// src/components/bhHeader.vue